import {useTranslation} from "ni18n";
import React from "react";

import {covidReadyUrl} from "../../_common/_constants";
import {V5Img} from "../../_common/Carbon";
import {Btn, ImgWithBg} from "../V5Comp";
import styles from "./Hero.module.scss";

const Hero = ({imgExt, landingPageData}: any) => {
  const i18n = useTranslation();
  const {name, ctaLink = covidReadyUrl} = landingPageData;
  return (
    <ImgWithBg
      className={`${styles.wrap} df aic`}
      bgImage="/covidReadyForOrgs/hero"
      style={{backgroundSize: "60%"}}
    >
      <div className={styles.inner}>
        <a className={`cIcon-arrow-down ${styles.arr}`} href="#how">
          <span className="visually-hidden">{i18n.t("Scroll Down")}</span>
        </a>
        <div className={styles.l}>
          <h1 className={styles.l2}>
            {i18n.t("{{name}} is offering COVID-19 workplace management through Carbon Health", {
              name,
            })}
          </h1>
          <p className={styles.l3}>
            {i18n.t(
              "Our shared goal is to keep all employees safe, healthy, and prevent infection outbreaks in the workplace.",
            )}
          </p>

          <div className={styles.l4}>
            <Btn href={ctaLink} color="#1C4F75" bg="#F9F9F9" fontSize="16px">
              {i18n.t("Get started")}
            </Btn>
            <Btn href="#how" color="#F9F9F9" bg="#408FAD" fontSize="16px" className={styles.btn2}>
              {i18n.t("Learn more")}
            </Btn>
          </div>
        </div>
        <V5Img className={styles.r2} src={`/covidReady2/mon-phone2.${imgExt}`} width="298" />
      </div>
    </ImgWithBg>
  );
};

export default Hero;
